import React, { useState, useEffect } from 'react';
import { GetRequest } from 'components/common/index.js';
import CartonMaterialsSection from 'components/quote_builder_widget/CartonMaterialsSection';
import CorrugatedCardboardMaterialsSection from 'components/quote_builder_widget/CorrugatedCardboardMaterialsSection';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const MATERIAL_SECTIONS = [
  { id: 'carton_materials', label: 'quote_builder_widget.materials_menu_cartons', materialType: 'carton_material', Content: CartonMaterialsSection },
  { id: 'corrugated_materials', label: 'quote_builder_widget.materials_menu_corrugated_cardboards', materialType: 'corrugated_cardboard_material', Content: CorrugatedCardboardMaterialsSection },
];

const MaterialsMenuSection = ({ activeSection, onSectionChange, onMaterialsChange }) => {
  const [enabledCounts, setEnabledCounts] = useState({});
  const activeMaterialSection = MATERIAL_SECTIONS.find((section) => section.id === activeSection) || MATERIAL_SECTIONS[0];
  const { Content } = activeMaterialSection;

  const fetchEnabledCounts = () => {
    MATERIAL_SECTIONS.forEach((section) => {
      GetRequest({
        url: `/quote-builder/user_unit_prices/list/settings_list/${section.materialType}/${window.locale || 'en'}`,
        callback: (materials) => {
          const count = materials.filter((material) => material.widget_enabled === 'true').length;
          setEnabledCounts((previous) => ({ ...previous, [section.id]: count }));
        }
      });
    });
  };

  useEffect(fetchEnabledCounts, []);

  const handleMaterialsChange = () => {
    fetchEnabledCounts();
    onMaterialsChange();
  };

  return (
    <div className={styles.materialsLayout}>
      <nav className={`dct-menu__panel ${styles.materialsMenu}`} aria-label={t('quote_builder_widget.section_materials')}>
        <ul className="dct-menu__list">
          {MATERIAL_SECTIONS.map((section) => {
            const isCurrent = section.id === activeMaterialSection.id;
            return (
              <li key={section.id}>
                <a
                  href={`#${section.id}`}
                  className={isCurrent ? 'dct-menu__link is-current' : 'dct-menu__link'}
                  aria-current={isCurrent ? 'page' : undefined}
                  onClick={(event) => {
                    event.preventDefault();
                    onSectionChange(section.id);
                  }}
                >
                  {t(section.label)}
                  {enabledCounts[section.id] !== undefined && (
                    <span className="dct-menu__count"> ({enabledCounts[section.id]})</span>
                  )}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className={styles.materialsContent}>
        <div className={styles.fieldGroup}>
          <Content onMaterialsChange={handleMaterialsChange} />
        </div>
      </div>
    </div>
  );
};

export default MaterialsMenuSection;
